import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { slotAreaFields } from './slot-area-fields.js'

export function flattenSlotLayout(slot: unknown): SchemaField[] {
  const { main, sidebar } = slotAreaFields(slot)
  return [...main, ...sidebar]
}
